$(document).ready(function(){
  $('.vv_ugc_carousel').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0050/1304/5312/files/Arrow_Right_1.png?v=1738570982'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0050/1304/5312/files/Arrow_Right.png?v=1738570982'/></button>",
        responsive: [
            {
                breakpoint: 678,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '40px',
                }
            }
        ]
    });

  $(document).on("click",".vv_ugc_block",function() {
      var currentState = $(this).find('.vv_ugc_video_control').attr('data');
      console.log(currentState, 'CURRENT STATE OF UGC');
  
      var clickedVideo = $(this).find('video')[0];
    
        // Pause all other videos except the clicked one
        $('.vv_ugc_block').each(function() {
            var video = $(this).find('video')[0];
            if (video && video !== clickedVideo && !video.paused) {
                video.pause();
                $(this).find('.bdru_Control_pause').hide();
                $(this).find('.bdru_Control_play').show();
            }
        });
    
        // Toggle play/pause for the clicked video
        $('.vv_ugc_video_control').removeClass('notVisible'); 
        if (clickedVideo) {
            if (clickedVideo.paused) {
                clickedVideo.play();
                $(this).find('.bdru_Control_pause').css('display', 'flex');
                $(this).find('.bdru_Control_play').hide();
                $(this).find('.vv_ugc_video_control').addClass('notVisible');
            } else {
                clickedVideo.pause();
                $(this).find('.bdru_Control_pause').hide();
                $(this).find('.bdru_Control_play').css('display', 'flex');
            }
        }
  
      if (currentState == '0'){
          $(this).find('.vv_ugc_video_control').attr('data', '1');
          $(this).find('.vv_ugc_video_control').find('.bb_btn').html('Pause');
      }
      else{
          $(this).find('.vv_ugc_video_control').attr('data', '0');
          $(this).find('.vv_ugc_video_control').find('.bb_btn').html('Play');
      }
  });

  $('.vv_ugc_block').mouseover(function(){
      $(this).addClass('hovered');
  });
  $('.vv_ugc_block').mouseleave(function(){
      $(this).removeClass('hovered');
  });


  $('.homepage-faq_block').click(function(){
    $(this).find('.homepage-faq_content').slideToggle();
    $(this).toggleClass('active');
  });

  $('.homepage-spec_block').click(function(){
    $('.homepage-spec_block').removeClass('active');
    $(this).addClass('active');
    var currentId = $(this).attr('data-id');

    $('.homepage-specs_container').addClass('hidden');
    $('.homepage-specs_container[data-id="'+currentId+'"]').removeClass('hidden');
  });
  
});